export const LOCALE_PREFIX = 'scenes.Gnosus.scenes.Report.components.Workspace.components.Blocks.Grants'

export const GRANTS_TABLE_CHANGE = 'GRANTS_TABLE_CHANGE'
export const GRANTS_TABLE_DATA_RECEIVED = 'GRANTS_TABLE_DATA_RECEIVED'
export const GRANTS_TABLE_LOADING_TRUE = 'GRANTS_TABLE_LOADING_TRUE'
export const GRANTS_TABLE_LOADING_FALSE = 'GRANTS_TABLE_LOADING_FALSE'

export const GRANTS_TABLE_CHANGE_REQUEST = (id) => `GRANTS_${id}_TABLE_CHANGE_REQUEST`
